// extracted by mini-css-extract-plugin
export default {"skillsContainer":"skills_skillsContainer__IvlQj","skillscardimg":"skills_skillscardimg__BY+47"};